import { lazy } from "react";

import CareIcon from "@/CAREUI/icons/CareIcon";

import { PluginManifest } from "@/pluginTypes";

const SafetyFacilityPage = lazy(() => import("./SafetyFacilityPage"));

// Wording: public/locale/<lang>.json, loaded by CARE as this plugin's i18n
// namespace (served at /local-plugins/myhis-safety/locale/).
// Every screen talks to the myhis_safety plug only. While its SAFETY_ENABLED
// flag is off the gate lets every action through and the pages say so.
const manifest: PluginManifest = {
  plugin: "myhis-safety",
  routes: {
    // The facility's safety desk: the event log and the setup (managers).
    "/facility/:facilityId/safety": ({ facilityId }) => (
      <SafetyFacilityPage facilityId={facilityId} />
    ),
  },
  components: {
    // The guard CARE calls before administering, collecting and starting a
    // procedure (the ActionGuard slot).
    ActionGuard: lazy(() => import("./SafetyGate")),
    // "Print wristband" on the patient card.
    PatientInfoCardQuickActions: lazy(() => import("./PrintWristbandButton")),
    FacilityHomeActions: lazy(() => import("./SafetyDeskButton")),
  },
  // The safety desk in the facility's left navigation (url prefixed with
  // /facility/<id>/ by CARE; a static label, read before the locale loads).
  navItems: [
    {
      name: "Patient safety",
      url: "safety",
      icon: <CareIcon icon="l-shield-check" />,
    },
  ],
};

export default manifest;
